import ProductResultCount from "./ProductResultCounts";
import ProductPerPageOption from "./ProductPerPageOption";
import ProductSortByOption from "./ProductSortByOption";
import React from "react";

function ProductsHeader({products}) {
    return (
        <div className="products-header">
            <ProductResultCount products={products}/>
            <ProductSortByOption/>
            <ProductPerPageOption/>
        </div>
    )
}

export default ProductsHeader;